import { useEffect } from "react";

/**
 * Custom hook to detect clicks outside of a specified element
 * @param ref - React ref object pointing to the element to monitor
 * @param handler - Function to call when a click outside occurs
 */
export function useClickOutside(
  ref: React.RefObject<HTMLElement>,
  handler: () => void
) {
  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        handler();
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [ref, handler]);
}
